module.exports = __webpack_public_path__ + "fonts/Avenir-Roman.c6d37b26.ttf";